import Api from '@/services/api'

export default {
  namespaced: true,
  state: {
    accommodation_types: [],
    trip_types: [],
    retail_places: [],
    landmarks: [],
    stores: [],
    restaurants: [],

    fetching_retail_places: false,
    fetching_trip_types: false,
    fetching_accommodation_types: false,
    fetching_landmarks: false,
    fetching_stores: false,
    fetching_restaurants: false
  },

  mutations: {
    setAccommodationTypes(state, types) {
      state.accommodation_types = types
    },

    setFetchingAccommodationTypes(state, status) {
      state.fetching_accommodation_types = status
    },

    clearAccommodationTypes(state) {
      state.accommodation_types = []
    },

    setFetchingTripTypes(state, status) {
      state.fetching_trip_types = status
    },

    setTripTypes(state, types) {
      state.trip_types = types
    },

    clearTripTypes(state) {
      state.trip_types = []
    },

    setFetchingRetailPlaces(state, status) {
      state.fetching_retail_places = status
    },

    setRetailPlaces(state, places) {
      state.retail_places = places
    },

    setFetchingLandmarks(state, status) {
      state.fetching_landmarks = status
    },

    setFetchingStores(state, status) {
      state.fetching_stores = status
    },

    setFetchingRestaurants(state, status) {
      state.fetching_restaurants = status
    },

    setLandmarks(state, landmarks) {
      state.landmarks = landmarks
    },

    setStores(state, stores) {
      state.stores = stores
    },

    setRestaurants(state, restaurants) {
      state.restaurants = restaurants
    }
  },

  actions: {
    async getAccommodationTypes({ commit }) {
      commit('setFetchingAccommodationTypes', true)
      const { data } = await Api.get(
        `trip-options?only=accommodation_type`
      ).finally(() => commit('setFetchingAccommodationTypes', false))
      commit('setAccommodationTypes', data.data.accommodation_types)
    },

    async getTripTypes({ commit }) {
      commit('setFetchingTripTypes', true)
      const { data } = await Api.get(
        `trip-options?only=trip_type`
      ).finally(() => commit('setFetchingTripTypes', false))
      commit('setTripTypes', data.data.trip_types)
    },

    async getRetailPlaces({ commit }) {
      commit('setFetchingRetailPlaces', true)
      const { data } = await Api.get(
        `admin/places?filter[types]=restaurant,store&all=true`
      ).finally(() => {
        commit('setFetchingRetailPlaces', false)
      })

      commit('setRetailPlaces', data.data)
    },

    async getLandmarks({ commit }) {
      commit('setFetchingLandmarks', true)
      const { data } = await Api.get(
        `admin/places?filter[types]=landmark&all=true`
      ).finally(() => commit('setFetchingLandmarks', false))
      commit('setLandmarks', data.data)
    },

    async getStores({ commit }) {
      commit('setFetchingStores', true)
      const { data } = await Api.get(
        `admin/places?filter[types]=store&all=true`
      ).finally(() => commit('setFetchingStores', false))
      commit('setStores', data.data)
    },

    async getRestaurants({ commit }) {
      commit('setFetchingRestaurants', true)
      const { data } = await Api.get(
        `admin/places?filter[types]=restaurant&all=true`
      ).finally(() => commit('setFetchingRestaurants', false))
      commit('setRestaurants', data.data)
    }
  }
}
